import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import { useTranslation } from "react-i18next";
import Layout from "../../../../../components/Layout";
import CreateMeetingContent from "../../../../../components/Pages/Vaadim/SinglePage/VaadTabs/MeetingsTab/CreateMeeting";

const { displayName } = config;

export default function AddMeeting(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Add Meetings`;
  }, []);

  return (
    <Layout>
      <CreateMeetingContent />
    </Layout>
  );
}
